import { rtlLanguages, resources } from "translation/i18n";
import logo from "assets/logo.jpg";
import landing from "assets/landing.png";
import fullLogo from "assets/fulllogo.jpg";
import { API_BASE_URL } from "utils/constants";
import { groups, userDefinedEntities } from "./entities";
import { authConfig, authUserDefinedEntities } from "authEntities";
import { customTheme } from "components/Theme";
import { store } from "./index";
import rootReducer from "./reducers";
import { history } from "configureStore";

const storeDispatcher = (type) => {
  store.dispatch({ type });
};

const replaceReducer = (adminPanelReducers) => {
  const nextReducer = rootReducer(history, adminPanelReducers);
  store.replaceReducer(nextReducer);
};

export const adminConfigs = {
  languageResources: resources,
  rtlLanguages,
  logo,
  landingImage: landing,
  fullLogo,
  url: API_BASE_URL,
  groups,
  userDefinedEntities,
  authUserDefinedEntities,
  authConfig,
  theme: customTheme,
  privateRouteURL: "/admin",
  storeDispatcher,
  replaceReducer,
};
